import { ExperimentsMethods } from "../..";

export const getPremiumCopiratingText = () => {
	const isPremiumFlagTurnedOn = ExperimentsMethods.isVariantActive(
		ExperimentsMethods.ExperimentsKeys.PricingV2
	);
	return isPremiumFlagTurnedOn ? "Upgrade" : "Get Premium";
};
